document.addEventListener('DOMContentLoaded', async () => {
  const audio = document.getElementById('audio');
  const waveform = document.getElementById('waveform');
  const playBtn = document.getElementById('playBtn');
  const iconPlay = document.getElementById('iconPlay');
  const iconPause = document.getElementById('iconPause');
  if (!audio || !waveform || !playBtn || !audio.src) return;

  let allBars = [];
  let rawData = null;
  let BAR_COUNT = 60;
  let lastPlayedCount = -1;

  function getBarCount(width) {
    console.log(width)
    if (width < 100) return 20;
    if (width < 150) return 25;
    if (width < 200) return 25;
    if (width < 250) return 35;
    if (width < 300) return 45;
    if (width < 350) return 50;
    if (width < 400) return 55;
    if (width < 450) return 62;
    if (width < 500) return 65;
    if (width < 550) return 70;
    return 80;
  }

  const computeHeights = (data, count) => {
    const blockSize = Math.floor(data.length / count);
    const heights = Array.from({ length: count }, (_, i) => {
      const block = data.slice(i * blockSize, (i + 1) * blockSize);
      const rms = Math.sqrt(block.reduce((sum, v) => sum + v * v, 0) / block.length);
      return rms;
    });
    const max = Math.max(...heights);
    return heights.map((v) => 10 + (v / max) * 90);
  };

  const buildBars = (heights) => {
    if (allBars.length !== heights.length) {
      waveform.innerHTML = '';
      allBars = heights.map(() => {
        const bar = document.createElement('span');
        bar.className = 'bar';
        waveform.appendChild(bar);
        return bar;
      });
    }
    allBars.forEach((bar, i) => {
      bar.style.height = Math.round(heights[i]) + '%';
    });
  };

  const updateBars = (pct) => {
    const progress = pct !== undefined ? pct : audio.duration ? audio.currentTime / audio.duration : 0;
    const playedCount = Math.round(progress * BAR_COUNT);
    if (playedCount === lastPlayedCount) return;
    lastPlayedCount = playedCount;
    allBars.forEach((bar, i) => bar.classList.toggle('played', i < playedCount));
  };

  const extractWaveform = async () => {
    const response = await fetch(audio.src);
    const arrayBuffer = await response.arrayBuffer();
    const ctx = new AudioContext();
    const audioBuffer = await ctx.decodeAudioData(arrayBuffer);
    await ctx.close();
    rawData = audioBuffer.getChannelData(0);
    return computeHeights(rawData, BAR_COUNT);
  };

  const setPlaying = (playing) => {
    iconPlay.style.display = playing ? 'none' : 'block';
    iconPause.style.display = playing ? 'block' : 'none';
    playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Lecture');
  };

  // Init ResizeObserver avant le fetch pour avoir la bonne largeur dès le départ
  const ro = new ResizeObserver((entries) => {
    const width = entries[0].contentRect.width;
    const newCount = getBarCount(width);
    if (newCount === BAR_COUNT || !rawData) return;
    BAR_COUNT = newCount;
    lastPlayedCount = -1;
    const pct = audio.duration ? audio.currentTime / audio.duration : 0;
    buildBars(computeHeights(rawData, BAR_COUNT));
    updateBars(pct);
  });
  ro.observe(waveform);

  // Init BAR_COUNT avec la largeur réelle avant le fetch
  BAR_COUNT = getBarCount(waveform.getBoundingClientRect().width);

  try {
    const heights = await extractWaveform();
    buildBars(heights);
  } catch {
    const fallback = Array.from({ length: BAR_COUNT }, () => Math.round(20 + Math.random() * 80));
    buildBars(fallback);
  }

  playBtn.addEventListener('click', () => {
    audio.paused ? audio.play() : audio.pause();
  });

  audio.addEventListener('play', () => setPlaying(true));
  audio.addEventListener('pause', () => setPlaying(false));
  audio.addEventListener('timeupdate', () => updateBars());
  audio.addEventListener('ended', () => {
    setPlaying(false);
    lastPlayedCount = -1;
    allBars.forEach((bar) => bar.classList.remove('played'));
  });

  waveform.addEventListener('click', (e) => {
    if (!audio.duration) return;
    const rect = waveform.getBoundingClientRect();
    audio.currentTime = ((e.clientX - rect.left) / rect.width) * audio.duration;
  });
});